// extracted by mini-css-extract-plugin
export default {"ExtraPerformanceAdviceSection":"style_ExtraPerformanceAdviceSection__u+G91","GlobalText2":"style_GlobalText2__+AY38"};